import { runQuery } from "../store/api/runtime";
import { matchesApi } from "../store/api/matchesApi";

export interface MatchTradeSummary {
  id: string;
  cardName: string;
  game: string;
  condition?: string | null;
  photoUrl?: string | null;
  zipCode?: string;
  radius?: number | null;
  userId: string;
}

export interface MatchBountySummary {
  id: string;
  cardName: string;
  game: string;
  desiredCondition?: string | null;
  gradingCompany?: string | null;
  gradeNumber?: string | null;
  photoUrl?: string | null;
  zipCode?: string;
  radius?: number | null;
  userId: string;
}

export interface MatchItem {
  id: string;
  distanceMiles?: number | null;
  status?: string | null;
  createdAt?: string;
  lastNotifiedAt?: string | null;
  trade?: MatchTradeSummary | null;
  bounty?: MatchBountySummary | null;
}

export interface MyMatchesResponse {
  asTrader: MatchItem[];
  asBountyOwner: MatchItem[];
}

export async function getMyMatches(): Promise<MyMatchesResponse> {
  return runQuery(matchesApi.endpoints.getMyMatches.initiate, undefined);
}
